/* eslint-disable max-len */
import React, { useState, useContext, Suspense } from 'react';
import PropTypes from 'prop-types';
import { QueryContext } from '@thd-nucleus/data-sources';
import { QuickViewLazy } from '@thd-olt-component-react/product-bundle';
import { BundleImage } from '../BundleImage';

const LaundryBundleImage = ({
  itemId, src, alt
}) => {
  const [isQuickViewOpen, setIsQuickViewOpen] = useState(false);
  const { defaultVariables } = useContext(QueryContext) || {};
  const openQuickView = () => {
    if (!isQuickViewOpen) {
      setIsQuickViewOpen(true);
    }
  };
  return (
    <>
      <button
        data-testid="product-list-product-image"
        onClick={() => openQuickView()}
        type="button"
      >
        <BundleImage
          src={src}
          alt={alt}
        />
      </button>

      {typeof window !== 'undefined' && isQuickViewOpen && (
        <Suspense fallback={<div />}>
          <QuickViewLazy
            isOpen={isQuickViewOpen}
            onClose={() => {
              setIsQuickViewOpen(false);
            }}
            fetch={isQuickViewOpen}
            itemId={itemId}
            paginateCarousel={false}
            openDetailsInNewTab
            triggerViewFullDetailsAnalytics={false}
            defaultVariables={defaultVariables}
          />
        </Suspense>
      )}
    </>
  );
};

LaundryBundleImage.propTypes = {
  itemId: PropTypes.string.isRequired,
  src: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired
};

export { LaundryBundleImage };